module.exports = __webpack_public_path__ + "static/lato-light-483a27c988018f92133995b7d1453248.ttf";